__turbopack_context__.v({
  "button": "MBxCha_button",
  "container": "MBxCha_container",
  "iconNext": "MBxCha_iconNext",
});
